// extracted by mini-css-extract-plugin
export default {"pageLayout":"PageLayout_pageLayout__jOWXZ","container":"PageLayout_container__6HTGE"};